import { css } from "styled-components";

export const flexBox = (
  direction = "row",
  jusitfy = "flex-start",
  align = "flex-start",
  gap = "0"
) => css`
  display: flex;
  flex-direction: ${direction};
  justify-content: ${jusitfy};
  align-items: ${align};
  gap: ${gap};
`;

export const translucentText = (color, fontSize) => css`
  color: ${color || "#fff"};
  opacity: 0.6;
  font-size: ${fontSize || "14px"};
`;

export const BoldText = (color) => css`
  color: ${color || "#fff"};
  font-weight: 700;
  font-size: 24px;
`;
